import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { 
  selectAppData, 
  selectPackagesData, 
  selectBannersData,
  selectAppName,
  selectAppId,
  selectHeader,
  selectFooter,
  selectNavigation
} from '../selectors/applicationSelectors';

// Hook para acceder de forma segura al estado de Redux
export const useSafeState = (selector, defaultValue = null) => {
  try {
    const value = useSelector(selector);
    return value !== undefined && value !== null ? value : defaultValue;
  } catch (error) {
    console.error('Error accessing Redux state:', error);
    return defaultValue;
  }
};

// Hook específico para datos de aplicación USANDO SELECTORES MEMOIZADOS
export const useAppData = () => {
  return useSelector(selectAppData);
};

// Hook para datos de paquetes USANDO SELECTORES MEMOIZADOS
export const usePackagesData = () => {
  return useSelector(selectPackagesData);
};

// Hook para datos de banners USANDO SELECTORES MEMOIZADOS
export const useBannersData = () => {
  return useSelector(selectBannersData);
};

// Hooks individuales para casos específicos
export const useAppName = () => {
  return useSelector(selectAppName);
};

export const useAppId = () => {
  return useSelector(selectAppId);
};

export const useHeader = () => {
  return useSelector(selectHeader);
};

export const useFooter = () => {
  return useSelector(selectFooter);
};

export const useNavigation = () => {
  return useSelector(selectNavigation);
};

// Hook para validación de datos CON MEMOIZACIÓN
export const useDataValidation = (data, requiredFields = []) => {
  const validateData = useMemo(() => {
    if (!data) return false;
    
    for (const field of requiredFields) {
      if (data[field] === undefined || data[field] === null || data[field] === '') {
        return false;
      }
    }
    
    return true;
  }, [data, requiredFields]);

  const missingFields = useMemo(() => {
    return requiredFields.filter(field => 
      !data || data[field] === undefined || data[field] === null || data[field] === ''
    );
  }, [data, requiredFields]);
  
  // MEMOIZAR el objeto de retorno
  return useMemo(() => ({
    isValid: validateData,
    missingFields
  }), [validateData, missingFields]);
}; 